export const MUTATION_KEYS = {
  auth: {
    all: () => ['auth'] as const,
    authenticate: () => [...MUTATION_KEYS.auth.all(), 'authenticate'] as const,
    login: () => [...MUTATION_KEYS.auth.all(), 'login'] as const,
    loginToCustomer: () => [...MUTATION_KEYS.auth.all(), 'login-to-customer'] as const,
    logoutFromCustomer: () => [...MUTATION_KEYS.auth.all(), 'logout-from-customer'] as const,
    logout: () => [...MUTATION_KEYS.auth.all(), 'logout'] as const,
    resetPassword: () => [...MUTATION_KEYS.auth.all(), 'reset-password'] as const,
    setPassword: () => [...MUTATION_KEYS.auth.all(), 'set-password'] as const,
    identify: () => [...MUTATION_KEYS.auth.all(), 'identify'] as const,
    generateOtp: () => [...MUTATION_KEYS.auth.all(), 'generate-otp'] as const,
    verifyOtp: () => [...MUTATION_KEYS.auth.all(), 'verify-otp'] as const,
    missingRecoveryCode: () => [...MUTATION_KEYS.auth.all(), 'missing-recovery-code'] as const,
    verifyTotp: () => [...MUTATION_KEYS.auth.all(), 'verify-totp'] as const,
    verifyBackupCode: () => [...MUTATION_KEYS.auth.all(), 'verify-backup-code'] as const,
    enableTwoFactor: () => [...MUTATION_KEYS.auth.all(), 'enable-two-factor'] as const,
    disableTwoFactor: () => [...MUTATION_KEYS.auth.all(), 'disable-two-factor'] as const,
    oauthConsent: () => [...MUTATION_KEYS.auth.all(), 'oauth-consent'] as const,
  },
  establishments: {
    all: () => ['establishments'] as const,
    import: () => [...MUTATION_KEYS.establishments.all(), 'import'] as const,
  },
  supplyPoints: {
    all: () => ['supplyPoints'] as const,
    import: () => [...MUTATION_KEYS.supplyPoints.all(), 'import'] as const,
  },
  meters: {
    all: () => ['meters'] as const,
    create: () => [...MUTATION_KEYS.meters.all(), 'create'] as const,
    update: () => [...MUTATION_KEYS.meters.all(), 'update'] as const,
    delete: () => [...MUTATION_KEYS.meters.all(), 'delete'] as const,
    move: () => [...MUTATION_KEYS.meters.all(), 'move'] as const,
    import: () => [...MUTATION_KEYS.meters.all(), 'import'] as const,
    registers: {
      all: () => [...MUTATION_KEYS.meters.all(), 'registers'] as const,
      create: () => [...MUTATION_KEYS.meters.registers.all(), 'registers', 'create'] as const,
      update: () => [...MUTATION_KEYS.meters.registers.all(), 'registers', 'update'] as const,
      delete: () => [...MUTATION_KEYS.meters.registers.all(), 'registers', 'delete'] as const,
    },
    revisions: {
      all: () => [...MUTATION_KEYS.meters.all(), 'registers'] as const,
      update: () => [...MUTATION_KEYS.meters.registers.all(), 'registers', 'update'] as const,
      revert: () => [...MUTATION_KEYS.meters.registers.all(), 'registers', 'report'] as const,
      delete: () => [...MUTATION_KEYS.meters.registers.all(), 'registers', 'delete'] as const,
    },
  },
  floorPlans: {
    all: () => ['floor-plans'] as const,
    create: () => [...MUTATION_KEYS.floorPlans.all(), 'create'] as const,
    update: () => [...MUTATION_KEYS.floorPlans.all(), 'update'] as const,
    delete: () => [...MUTATION_KEYS.floorPlans.all(), 'delete'] as const,
  },
  files: {
    all: () => ['files'] as const,
    create: () => [...MUTATION_KEYS.files.all(), 'create'] as const,
    update: () => [...MUTATION_KEYS.files.all(), 'update'] as const,
    delete: () => [...MUTATION_KEYS.files.all(), 'delete'] as const,
  },
  exports: {
    all: () => ['exports'] as const,
    create: () => [...MUTATION_KEYS.exports.all(), 'create'] as const,
    download: () => [...MUTATION_KEYS.exports.all(), 'download'] as const,
    getStatus: () => [...MUTATION_KEYS.exports.all(), 'get-status'],
  },
  users: {
    all: () => ['users'] as const,
    create: () => [...MUTATION_KEYS.users.all(), 'create'] as const,
    update: () => [...MUTATION_KEYS.users.all(), 'update'] as const,
    delete: () => [...MUTATION_KEYS.users.all(), 'delete'] as const,
    import: () => [...MUTATION_KEYS.users.all(), 'import'] as const,
    favourites: {
      all: () => [...MUTATION_KEYS.users.all(), 'favourites', 'all'] as const,
      create: () => [...MUTATION_KEYS.users.favourites.all(), 'favourites', 'create'] as const,
      update: () => [...MUTATION_KEYS.users.favourites.all(), 'favourites', 'update'] as const,
      delete: () => [...MUTATION_KEYS.users.favourites.all(), 'favourites', 'delete'] as const,
    },
    me: {
      grantConsent: () => [...MUTATION_KEYS.users.all(), 'me', 'consents'] as const,
    },
  },
  leases: {
    all: () => ['leases'] as const,
    create: () => [...MUTATION_KEYS.leases.all(), 'create'] as const,
    update: () => [...MUTATION_KEYS.leases.all(), 'update'] as const,
    delete: () => [...MUTATION_KEYS.leases.all(), 'delete'] as const,
  },
  billings: {
    all: () => ['billings'] as const,
    calculate: () => [...MUTATION_KEYS.billings.all(), 'calculate'] as const,
    preview: () => [...MUTATION_KEYS.billings.all(), 'preview'] as const,
  },
  records: {
    emissionRecords: {
      all: () => ['records', 'emission-records'] as const,
      import: () => [...MUTATION_KEYS.records.emissionRecords.all(), 'import'] as const,
    },
    emissionFactors: {
      all: () => ['records', 'emission-factors'] as const,
      create: () => [...MUTATION_KEYS.records.emissionFactors.all(), 'create'] as const,
      update: () => [...MUTATION_KEYS.records.emissionFactors.all(), 'update'] as const,
      delete: () => [...MUTATION_KEYS.records.emissionFactors.all(), 'delete'] as const,
      import: () => [...MUTATION_KEYS.records.emissionFactors.all(), 'import'] as const,
    },
    manual: {
      all: () => ['records', 'manual'] as const,
      import: () => [...MUTATION_KEYS.records.manual.all(), 'import'] as const,
    },
    invoices: {
      all: () => ['records', 'invoices'] as const,
      import: () => [...MUTATION_KEYS.records.invoices.all(), 'import'] as const,
    },
  },
} as const;
